import { render, staticRenderFns } from "./CoursesPage.vue?vue&type=template&id=fafe1bf2&"
import script from "./CoursesPage.vue?vue&type=script&lang=js&"
export * from "./CoursesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports